module.exports = __webpack_public_path__ + "img/right.fab13450.png";